module.exports = __webpack_public_path__ + "img/trends_14.52d70716.jpg";